module.exports = __webpack_public_path__ + "static/media/buglasan.c72f128b.jpg";